import { css, Theme } from '@emotion/react'

export const container = (theme: Theme) => css`
  width: 100%;
  max-width: 1190px;
  padding: 31px 24px;
  margin: 0 auto;
  background: ${theme.backgrounds.backgroundFour};
`

export const header = css`
  font-weight: 700;
`

export const tabsBlock = css`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 10px;
  margin-top: 31px;
  margin-bottom: 24px;
`

export const tab = (theme: Theme) => css`
  font-weight: 600;
  color: ${theme.typographyColors.typographyThree};
  padding: 12px 12px 8px;
  border-radius: 12px;
  cursor: pointer;
`

export const activeTab = (theme: Theme) => css`
  color: ${theme.typographyColors.typographyTwo};
  background: ${theme.colors.grayHover};
`
